import { colors } from 'fitify-ui'
import styled from 'styled-components'

export const StyledDocumentPageWrapper = styled.div``

export const StyledDocumentContainer = styled.div`
  max-width: 800px;
  padding: 0 20px;
  margin: 50px auto 0;
  line-height: 170%;

  h2,
  h3 {
    margin: 25px;
    font-weight: normal;
    text-align: center;
  }

  h4 {
    font-family: 'Graphik LCG', sans-serif;
    font-size: 16px;
    font-weight: bold;
    line-height: 170%;
  }

  b,
  strong {
    font-weight: 600;
  }

  i {
    font-style: italic;
  }

  a {
    color: ${colors.Blue700};
    overflow-wrap: anywhere;
    text-decoration: underline;
    word-wrap: break-word;
  }

  p {
    margin: 16px 0;
    font-size: 16px;
  }

  table {
    th {
      font-weight: bold;
    }

    td {
      overflow-wrap: break-word;
    }
  }

  ul {
    display: block;
    list-style-type: disc;
    margin-block: 1em;
    margin-inline: 0;
    padding-inline-start: 40px;

    li {
      overflow-wrap: anywhere;
    }
  }
`
